module.exports = __webpack_public_path__ + "img/NBA_SingleShotMiss.0422b328.png";